import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@mui/material';
import { tss } from 'tss-react/mui';
import type { ReactNode } from 'react';
import { Button } from '../Button';

type InformationDialogProps = {
    open: boolean;
    onClose(): void;
    title: ReactNode;
    content: ReactNode;
    button: ReactNode;
};
export const InformationDialog = (props: InformationDialogProps) => {
    const { classes } = useStyles();
    return (
        <Dialog open={props.open} maxWidth={'sm'}>
            <DialogTitle className={classes.title}>{props.title}</DialogTitle>
            <DialogContent className={classes.content}>
                {props.content}
            </DialogContent>
            <DialogActions className={classes.actions}>
                <Button onClick={props.onClose}>{props.button}</Button>
            </DialogActions>
        </Dialog>
    );
};

const useStyles = tss.create(({ theme }) => ({
    title: {
        background: theme.bino.color.primary,
        color: theme.bino.color.white,
        textAlign: 'center',
    },
    content: {},
    actions: {
        justifyContent: 'center',
    },
}));
